import { type CapiProductPage } from 'types/capi/pdp';

import StarEmpty from '~/assets/icons/StarEmpty';
import StarFull from '~/assets/icons/StarFull';
import StarHalf from '~/assets/icons/StarHalf';
import usePageData from '~/hooks/usePageData';

function displayRating(product: CapiProductPage) {
  return (
    product.variants.length && product.rating.average && product.rating.count
  );
}

const Rating = () => {
  const product = usePageData<CapiProductPage>();

  if (!displayRating(product)) return null;

  const rating = product.rating as Required<CapiProductPage['rating']>;

  const noOfFullStars = Math.floor(rating.average);
  const noOfEmptyStars =
    rating.average - noOfFullStars >= 0.5
      ? Math.floor(5 - rating.average)
      : Math.ceil(5 - rating.average);

  return (
    <div className="flex gap-2">
      <div className="flex items-center">
        {[...Array(noOfFullStars)].map((_, i) => (
          <StarFull height="16" width="16" fill="#FFAA00" key={i} />
        ))}
        {rating.average - noOfFullStars >= 0.5 && (
          <StarHalf height="16" width="16" fill="#FFAA00" key="half" />
        )}
        {[...Array(noOfEmptyStars)].map((_, i) => (
          <StarEmpty height="16" width="16" key={i} />
        ))}
      </div>
      <div className="flex items-center gap-1">
        <span className="text-sm text-black">{rating.average}</span>
        <span className="text-xs text-grey-hide">({rating.count})</span>
        <span className="hidden">Rating: {rating.average} out of 5 stars.</span>
      </div>
    </div>
  );
};

export default Rating;
